<template>
  <v-container >
      <v-layout row v-if="error">
        <v-flex xs12 sm6 offset-sm3>
          <v-alert :value="error.value" color="error">
            <v-btn icon><v-icon @click="onDismissed">close</v-icon></v-btn> {{error.message}}
          </v-alert>
        </v-flex>
      </v-layout>
      <!-- <v-layout row justify-center align-center>
        <v-flex xs12 py-4 class="text-xs-center">
          <v-img src="/static/final.png" class="h-center" max-width="320px" />
        </v-flex>
      </v-layout> -->
      <!-- <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-card-text>
              <v-container>
                <form @submit.prevent="onSignin">
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field name="usuario" label="Usuario" id="usuario" v-model="usuario" required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field label="Clave" v-model="password" type="password"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    
                    <v-flex xs12>
                      <v-btn type="submit" :disabled="loading" :loading="loading">
                        Iniciar Sesión
                        <span slot="loader" class="custom-loader">
                          <v-icon light>cached</v-icon>
                        </span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout> -->
  </v-container>
</template>

<script>

import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

import { http } from '@/axios'

export default {
  
  data () {
    return {
      unverified: true,
      loading: false,
    }
  },
  props:{
        usuario: {
            type: String,
        },
        password: {
            type: String
        },
        creditoId: {
            type: String
        }
    },
  computed: {
    ...mapGetters([ 'user', 'error' ])
  },
  watch: {
    user (value) {
       Vue.$log.debug(value);
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      } else {
        // this.$router.push('/')
      }
    }
  },
  async created () {
    console.log('created')
    console.log(this.$route.query)
      
      
      console.log('created 2')
      const usuario = this.$route.query.usuario;
      const password = this.$route.query.password;

console.log('usuario:' + usuario)
      this.$store.state.modoCargaRapidaComer = true;
      this.signUserIn(usuario,password);

      await this.loadInfoConsulta(this.$route.query.creditoId);    
  },
  methods: {
      ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
      async signUserIn(usuario,password){
          await this.$store.dispatch('signUserIn', { usuario: usuario, password: password });
      },
      async loadInfoConsulta(consultaId){
        this.loading = true;
        try {
            var result = await http.get('creditos/getinforesumida?id=' + consultaId);

            if(result != null){
              console.log(result)
              
              if(result.subEstadoId == 56)//falta legajo
              {
                this.$store.state.redirect = '/adjuntar-documentacion-comer?creditoId=' + result.id + 
                                                                            '&personaId=' + result.personaId + 
                                                                            '&empresaId=' + result.empresaId;
              }
              else
              {
                this.$store.state.redirect = '/alta-consulta-credito-v2/' + this.$route.query.creditoId;
              }
              console.log(this.$store.state.redirect);
            }
            else{
              this.alertError('Atención, ID de consulta inválido:' + consultaId);
            }
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    onDismissed(){}
  }
}
</script>